import { shopError } from "./shop-error.js";
import { shopSections } from "./shop-sections.js";
/** স্টোরফ্রন্টে ক্রেতারা যা পড়েন (apps/storefront, docs/specs/storefront.md)। */
export const shop = {
    language: "ভাষা",
    languages: { en: "English", bn: "বাংলা" },
    comingSoon: {
        title: "আমাদের অনলাইন শপ শিগগিরই খুলছে",
        body: "আমরা পণ্যগুলো অনলাইনে তুলছি। আজই অর্ডার করতে কল বা মেসেজ করুন।",
    },
    contact: {
        call: "কল করুন {{phone}}",
        email: "ই-মেইল করুন {{email}}",
    },
    cod: "ক্যাশ অন ডেলিভারি সুবিধা আছে",
    notFound: {
        title: "এই দোকানটি পাওয়া যাচ্ছে না",
        body: "ঠিকানাটি দেখুন, অথবা দোকানটি এখন বন্ধ থাকতে পারে।",
        code: "৪০৪",
        pageTitle: "পেজটি এখানে নেই",
        pageBody: "লিংকটি পুরনো বা ভুল লেখা হতে পারে। দোকানে খুঁজুন, অথবা কোনো ক্যাটাগরি থেকে শুরু করুন।",
        search: "দোকানে খুঁজুন",
        popular: "জনপ্রিয় ক্যাটাগরি",
        home: "হোম পেজে ফিরুন",
    },
    error: shopError,
    poweredBy: "Sobthik-এর অনলাইন স্টোর",
    demoBanner: "এটি থিমটির একটি ডেমো দোকান — ঘুরে দেখুন। এখানে অর্ডার নেওয়া হয় না।",
    nav: {
        home: "হোম",
        allProducts: "সব পণ্য",
        categories: "ক্যাটাগরি",
        menu: "দোকানের মেনু",
        searchLabel: "পণ্য খুঁজুন",
        searchPlaceholder: "পণ্য খুঁজুন…",
        search: "খুঁজুন",
    },
    home: {
        heroTitle: "{{name}}-এ স্বাগতম",
        heroBody: "অনলাইনে অর্ডার করুন, ঘরে বসে পেয়ে যান। ক্যাশ অন ডেলিভারি সুবিধা আছে।",
        heroBodyNoCod: "অনলাইনে অর্ডার করুন, ঘরে বসে পেয়ে যান।",
        shopNow: "এখনই কিনুন",
        categories: "ক্যাটাগরি অনুযায়ী দেখুন",
        newArrivals: "নতুন পণ্য",
        viewAll: "সব দেখুন",
        empty: "নতুন পণ্য শিগগিরই আসছে।",
    },
    price: {
        from: "{{price}} থেকে",
        save: "{{percent}}% ছাড়",
        mrp: "আগের দাম {{price}}",
    },
    availability: {
        in_stock: "স্টকে আছে",
        low: "অল্প বাকি",
        out: "স্টক শেষ",
        onlyLeft: "মাত্র {{quantity}} বাকি",
    },
    list: {
        title: "সব পণ্য",
        count_one: "{{n}}টি পণ্য",
        count_other: "{{n}}টি পণ্য",
        category: "ক্যাটাগরি",
        allCategories: "সব ক্যাটাগরি",
        sort: "সাজান",
        sorts: {
            newest: "নতুন আগে",
            price_asc: "দাম: কম থেকে বেশি",
            price_desc: "দাম: বেশি থেকে কম",
            name: "নাম",
        },
        inStock: "শুধু স্টকে থাকা",
        apply: "দেখান",
        more: "আরো দেখুন",
        empty: "কোনো পণ্য মেলেনি। অন্য ক্যাটাগরি দেখুন বা একটি ফিল্টার সরান।",
        filters: "ফিল্টার",
    },
    search: {
        title: "খুঁজুন",
        resultsFor: "“{{q}}”-এর ফলাফল",
        empty: "“{{q}}”-এর জন্য কিছু পাওয়া যায়নি। ছোট বা অন্য শব্দ দিয়ে খুঁজুন।",
        prompt: "কী খুঁজছেন লিখুন।",
    },
    product: {
        breadcrumb: "পথ নির্দেশ",
        choose: "{{option}}",
        unavailable: "এই কম্বিনেশনটি পাওয়া যাচ্ছে না।",
        description: "বিবরণ",
        details: "তথ্য",
        brand: "ব্র্যান্ড",
        category: "ক্যাটাগরি",
        orderByPhone: "কল করে অর্ডার করুন",
        checkoutSoon: "অনলাইন চেকআউট শিগগিরই চালু হবে। এখনই অর্ডার করতে কল করুন।",
        gallery: "পণ্যের ছবি",
        image: "{{total}}টির মধ্যে {{n}} নম্বর ছবি",
        noImage: "ছবি নেই",
        digital: {
            readOnline: "পেমেন্টের পরপরই এই ওয়েবসাইটে পড়ুন। কিছু ডেলিভারি হবে না।",
            buy: "ইবুক কিনুন",
            sample: "একটু পড়ে দেখুন",
            tag: "ইবুক",
            // The "Read a little" window on the product page.
            peekLoading: "নমুনা খোলা হচ্ছে…",
            peekFailed: "নমুনাটি খোলা গেল না। আবার চেষ্টা করুন।",
            peekEnd: "নমুনা এখানেই শেষ। পুরো বই পড়তে ইবুকটি কিনুন।",
        },
        book: {
            by: "লেখক",
            details: "বইয়ের তথ্য",
            roles: { author: "লেখক", translator: "অনুবাদক", editor: "সম্পাদক" },
            publisher: "প্রকাশনী",
            isbn: "আইএসবিএন",
            pages: "পৃষ্ঠা",
            edition: "সংস্করণ",
            language: "ভাষা",
            year: "প্রকাশকাল",
            noDownload: "ইবুক: কেনার পর এই ওয়েবসাইটেই পড়বেন। ডাউনলোড করার কোনো ফাইল নেই।",
        },
    },
    cart: {
        title: "আপনার কার্ট",
        add: "কার্টে যোগ করুন",
        added: "কার্টে যোগ হয়েছে",
        view: "কার্ট দেখুন",
        empty: "আপনার কার্ট খালি।",
        continue: "কেনাকাটা চালিয়ে যান",
        quantity: "পরিমাণ",
        update: "আপডেট",
        increase: "আরও একটি",
        decrease: "একটি কম",
        addFailed: "যোগ করা যায়নি। আবার চেষ্টা করুন।",
        remove: "সরান",
        subtotal: "সাবটোটাল",
        checkout: "চেকআউট",
        deliveryNote: "ডেলিভারি চার্জ চেকআউটে যোগ হবে।",
        items_one: "{{count}}টি পণ্য",
        items_other: "{{count}}টি পণ্য",
        problems: {
            unavailable: "আর পাওয়া যাচ্ছে না",
            out_of_stock: "স্টক শেষ — এগোতে এটি সরান",
            not_enough: "যথেষ্ট স্টক নেই — পরিমাণ কমান",
        },
        link: "কার্ট ({{count}})",
    },
    checkout: {
        title: "চেকআউট",
        contact: "আপনার তথ্য",
        name: "পুরো নাম",
        phone: "মোবাইল নম্বর",
        phoneHint: "নম্বর যাচাই করতে আমরা একটি কোড পাঠাব।",
        address: "ডেলিভারির ঠিকানা",
        district: "জেলা",
        chooseDistrict: "জেলা বাছুন",
        upazila: "এলাকা / থানা",
        chooseUpazila: "এলাকা বাছুন (ঐচ্ছিক)",
        addressLine: "বাসা, রোড, গ্রাম",
        note: "দোকানের জন্য নোট (ঐচ্ছিক)",
        payment: "পেমেন্ট",
        cod: "ক্যাশ অন ডেলিভারি",
        codHint: "পার্সেল পৌঁছালে ডেলিভারিম্যানকে টাকা দিন।",
        summary: "অর্ডারের সারাংশ",
        delivery: "ডেলিভারি",
        deliveryPending: "জেলা বাছুন",
        total: "মোট",
        sendCode: "কোড পাঠান",
        resend: "আবার পাঠান",
        code: "৬ অঙ্কের কোড",
        verify: "যাচাই করুন",
        verified: "নম্বর যাচাই হয়েছে",
        codeSent: "{{phone}} নম্বরে কোড পাঠানো হয়েছে।",
        place: "অর্ডার করুন",
        placing: "অর্ডার হচ্ছে…",
        errorGeneric: "কিছু একটা সমস্যা হয়েছে। আবার চেষ্টা করুন।",
        botCheck: "নিচের যাচাইটি সম্পন্ন করুন।",
        notReady: "আগে কার্টের পণ্যগুলো ঠিক করুন।",
        digitalNote: "ডিজিটাল পণ্য ডেলিভারি হয় না। পেমেন্ট হওয়ামাত্র আপনার লাইব্রেরিতে চলে আসবে।",
        digitalPayOnline: "ডিজিটাল পণ্যের দাম অনলাইনে দিতে হয়।",
        digitalNoPayment: "এই দোকানে এখনো অনলাইন পেমেন্ট চালু হয়নি, তাই এখন ডিজিটাল পণ্য কেনা যাবে না।",
    },
    placed: {
        title: "ধন্যবাদ! আপনার অর্ডার হয়েছে।",
        number: "অর্ডার নম্বর",
        total: "মোট দিতে হবে",
        next: "পাঠানোর আগে অর্ডার কনফার্ম করতে আমরা আপনাকে কল করব।",
        continue: "কেনাকাটা চালিয়ে যান",
    },
    pay: {
        choose: "কীভাবে পেমেন্ট করবেন?",
        gateways: { bkash: "bKash", nagad: "Nagad", sslcommerz: "কার্ড বা মোবাইল ওয়ালেট" },
        gatewayHint: "পেমেন্ট প্রোভাইডারের নিরাপদ পেজে টাকা দেবেন।",
        checking: "আপনার পেমেন্ট যাচাই হচ্ছে…",
        paid: "পেমেন্ট পাওয়া গেছে। ধন্যবাদ!",
        failed: "পেমেন্ট সম্পন্ন হয়নি। আপনার অর্ডার বাতিল হয়েছে; আবার অর্ডার করতে পারেন।",
        expired: "পেমেন্টের সময় পার হয়ে গেছে। আপনার অর্ডার বাতিল হয়েছে; আবার অর্ডার করতে পারেন।",
        open: "আমরা এখনো পেমেন্ট পাইনি।",
        inLibrary: "আপনার ডিজিটাল পণ্য লাইব্রেরিতে চলে এসেছে — এই ওয়েবসাইটেই খুলুন।",
        openLibrary: "আমার লাইব্রেরি খুলুন",
        retry: "এখন পেমেন্ট করুন",
        orderNumber: "অর্ডার {{number}}",
    },
    dashboard: {
        hello: "স্বাগতম, {{name}}",
        helloNoName: "স্বাগতম",
        nav: {
            overview: "সারসংক্ষেপ",
            orders: "অর্ডার",
            wishlist: "সেভ করা",
            reviews: "রিভিউ",
            addresses: "ঠিকানা",
            profile: "প্রোফাইল",
            security: "নিরাপত্তা",
            library: "লাইব্রেরি",
            signOut: "সাইন আউট",
        },
        latestOrder: "সর্বশেষ অর্ডার",
        noOrders: "আপনি এখনো অনলাইনে অর্ডার করেননি।",
        startShopping: "কেনাকাটা শুরু করুন",
        allOrders: "সব অর্ডার",
        ordersCount_one: "{{count}}টি অর্ডার",
        ordersCount_other: "{{count}}টি অর্ডার",
        savedCount_one: "{{count}}টি সেভ করা পণ্য",
        savedCount_other: "{{count}}টি সেভ করা পণ্য",
        tabs: { all: "সব", active: "চলমান", delivered: "ডেলিভারি হয়েছে", cancelled: "বাতিল" },
        searchOrders: "অর্ডার নম্বর",
        search: "খুঁজুন",
        noMatch: "এখানে কোনো অর্ডার নেই।",
        viewOrder: "দেখুন",
        track: "পার্সেল ট্র্যাক করুন",
        courier: "কুরিয়ার",
        consignment: "কনসাইনমেন্ট",
        courierStatus: "কুরিয়ারের অবস্থা",
        invoice: "ইনভয়েস (PDF)",
        orderAgain: "আবার অর্ডার করুন",
        cancel: "অর্ডার বাতিল করুন",
        cancelConfirm: "এই অর্ডারটি বাতিল করবেন? এটি আর ফেরানো যাবে না।",
        cancelReason: "কারণ (ঐচ্ছিক)",
        cancelled: "অর্ডারটি বাতিল হয়েছে।",
        cannotCancel: "কিছু বদলাতে চান? দোকানে ফোন করুন।",
        profileTitle: "প্রোফাইল",
        name: "নাম",
        language: "বার্তার ভাষা",
        offers: "SMS ও ই-মেইলে অফার পাঠান",
        save: "সংরক্ষণ করুন",
        saved: "সংরক্ষণ হয়েছে",
        email: "ইমেইল",
        mobile: "মোবাইল নম্বর",
        notSet: "যোগ করা হয়নি",
        verified: "যাচাই করা",
        notVerified: "যাচাই করা হয়নি",
        add: "যোগ করুন",
        change: "বদলান",
        verify: "যাচাই করুন",
        newEmail: "নতুন ইমেইল",
        newMobile: "নতুন মোবাইল নম্বর",
        currentPassword: "বর্তমান পাসওয়ার্ড",
        cancelEdit: "বাতিল",
        securityTitle: "নিরাপত্তা",
        passwordTitle: "পাসওয়ার্ড",
        setPassword: "পাসওয়ার্ড দিন",
        changePassword: "পাসওয়ার্ড বদলান",
        newPassword: "নতুন পাসওয়ার্ড",
        passwordChanged: "পাসওয়ার্ড বদলেছে। অন্য সব ডিভাইস থেকে সাইন আউট হয়েছে।",
        googleTitle: "Google",
        googleLinked: "Google-এর সাথে যুক্ত",
        googleNotLinked: "যুক্ত নয়",
        unlink: "আলাদা করুন",
        devicesTitle: "সাইন ইন করা ডিভাইস",
        thisDevice: "এই ডিভাইস",
        unknownDevice: "অজানা ডিভাইস",
        lastActive: "সক্রিয় {{date}}",
        via_password: "পাসওয়ার্ড",
        via_phone_code: "মোবাইল কোড",
        via_google: "Google",
        signOutDevice: "সাইন আউট",
        signOutOthers: "অন্য সব ডিভাইস থেকে সাইন আউট",
        deleteTitle: "অ্যাকাউন্ট মুছুন",
        deleteBody: "আপনার নাম, ইমেইল, মোবাইল নম্বর, ঠিকানা ও সেভ করা পণ্য মুছে যাবে। দোকানের হিসাবের জন্য আপনার অর্ডারগুলো থেকে যাবে।",
        deleteConfirm: "আমি বুঝেছি, আমার অ্যাকাউন্ট মুছে দিন",
        deleteButton: "অ্যাকাউন্ট মুছুন",
        addressesTitle: "ঠিকানা",
        addressesEmpty: "এখনো কোনো ঠিকানা সেভ করা নেই।",
        addAddress: "ঠিকানা যোগ করুন",
        editAddress: "বদলান",
        deleteAddress: "সরান",
        default: "ডিফল্ট",
        makeDefault: "ডিফল্ট হিসেবে ব্যবহার করুন",
        label: "নাম (বাসা, অফিস…)",
        recipient: "প্রাপকের নাম",
        district: "জেলা",
        upazila: "এলাকা / উপজেলা",
        line: "বাসা, রোড, এলাকা",
        reviewsTitle: "আমার রিভিউ",
        reviewsEmpty: "আপনি এখনো কোনো রিভিউ লেখেননি।",
        status_pending: "অনুমোদনের অপেক্ষায়",
        status_published: "প্রকাশিত",
        status_hidden: "লুকানো",
        shopReply: "দোকানের উত্তর",
        toReview: "আপনার রিভিউয়ের অপেক্ষায়",
    },
    authors: {
        books_one: "{{n}}টি বই",
        books_other: "{{n}}টি বই",
        booksBy: "{{name}}-এর বই",
        all: "সব লেখক",
    },
    library: {
        title: "আমার লাইব্রেরি",
        subtitle: "এই দোকান থেকে কেনা বই। যেকোনো ডিভাইসে এখানেই পড়ুন।",
        empty: "এখনো কিছু নেই। ইবুক কিনলে পেমেন্টের পরপরই এখানে দেখাবে।",
        read: "পড়ুন",
        continue: "আবার পড়ুন",
        progress: "{{total}} পৃষ্ঠার {{page}} নম্বর",
        notStarted: "এখনো শুরু করেননি",
        added: "যোগ হয়েছে {{date}}",
    },
    reader: {
        back: "লাইব্রেরিতে ফিরুন",
        previous: "আগের পৃষ্ঠা",
        next: "পরের পৃষ্ঠা",
        page: "পৃষ্ঠা",
        of: "/ {{total}}",
        zoomIn: "বড় করুন",
        zoomOut: "ছোট করুন",
        fitWidth: "প্রস্থ জুড়ে",
        fitPage: "পুরো পৃষ্ঠা",
        twoPages: "দুই পৃষ্ঠা",
        look: "পৃষ্ঠার রং",
        light: "সাদা",
        sepia: "সেপিয়া",
        dark: "কালো",
        fullscreen: "পূর্ণ পর্দা",
        contents: "সূচিপত্র",
        noContents: "এই বইয়ে সূচিপত্র নেই।",
        close: "বন্ধ করুন",
        loading: "বই খোলা হচ্ছে…",
        failed: "বইটি খোলা গেল না। আবার চেষ্টা করুন।",
        retry: "আবার চেষ্টা করুন",
        sample: "নমুনা",
        sampleNote: "আপনি নমুনা পড়ছেন। পুরো বই পড়তে ইবুকটি কিনুন।",
        buy: "ইবুক কিনুন",
    },
    auth: {
        signInTitle: "সাইন ইন করুন বা অ্যাকাউন্ট খুলুন",
        signInBody: "আপনার ইমেইল ঠিকানা বা মোবাইল নম্বর দিন।",
        identifier: "ইমেইল বা মোবাইল নম্বর",
        continue: "পরবর্তী",
        change: "বদলান",
        password: "পাসওয়ার্ড",
        showPassword: "পাসওয়ার্ড দেখুন",
        signIn: "সাইন ইন",
        forgot: "পাসওয়ার্ড ভুলে গেছেন?",
        useCode: "বরং কোড দিয়ে সাইন ইন করুন",
        usePassword: "পাসওয়ার্ড ব্যবহার করুন",
        signUpTitle: "আপনার অ্যাকাউন্ট খুলুন",
        signUpBody: "{{who}} দিয়ে এখনো কোনো অ্যাকাউন্ট নেই। এক মিনিটেই খোলা যায়।",
        name: "আপনার নাম",
        newPassword: "একটি পাসওয়ার্ড দিন",
        passwordHint: "কমপক্ষে ৮ অক্ষর। আপনার নম্বর, শুধু সংখ্যা বা খুব প্রচলিত পাসওয়ার্ড নয়।",
        createAccount: "অ্যাকাউন্ট খুলুন",
        codeSentPhone: "{{to}} নম্বরে একটি কোড পাঠানো হয়েছে।",
        codeSentEmail: "{{to}} ঠিকানায় একটি কোড পাঠানো হয়েছে।",
        codeNeeded: "এই দোকান আগে কোড দিয়ে {{who}} নিশ্চিত করতে বলে।",
        sendCode: "কোড পাঠান",
        resend: "আবার পাঠান",
        code: "৬ অঙ্কের কোড",
        confirmCode: "নিশ্চিত করুন",
        codeConfirmed: "নিশ্চিত হয়েছে",
        signUpOff: "এই দোকানে এটি দিয়ে নতুন অ্যাকাউন্ট খোলা যায় না। বরং ইমেইল বা মোবাইল নম্বর দিয়ে চেষ্টা করুন।",
        haveAccount: "আগে থেকেই অ্যাকাউন্ট আছে? সাইন ইন করুন",
        forgotTitle: "পাসওয়ার্ড রিসেট করুন",
        forgotBody: "আপনার অ্যাকাউন্টের ইমেইল ঠিকানা বা মোবাইল নম্বর দিন।",
        sendReset: "পাঠান",
        emailSent: "{{to}} দিয়ে কোনো অ্যাকাউন্ট থাকলে সেখানে একটি লিংক পাঠানো হয়েছে। লিংকটি ৩০ মিনিট কাজ করবে।",
        phoneSent: "{{to}} দিয়ে কোনো অ্যাকাউন্ট থাকলে সেখানে একটি কোড পাঠানো হয়েছে।",
        resetTitle: "নতুন পাসওয়ার্ড দিন",
        savePassword: "পাসওয়ার্ড সংরক্ষণ করুন",
        resetDone: "পাসওয়ার্ড বদলেছে এবং সব জায়গা থেকে সাইন আউট হয়েছে। নতুন পাসওয়ার্ড দিয়ে সাইন ইন করুন।",
        resetLinkMissing: "এই লিংকটি সম্পূর্ণ নয়। নতুন লিংক চেয়ে নিন।",
        backToSignIn: "সাইন ইনে ফিরে যান",
        errorGeneric: "কিছু একটা সমস্যা হয়েছে। আবার চেষ্টা করুন।",
        verifyTitle: "মোবাইল নম্বর যাচাই করুন",
        verifyBody: "অ্যাকাউন্ট খোলার আগে {{phone}} নম্বরে দেওয়া অর্ডারগুলো দেখতে নম্বরটি নিশ্চিত করুন।",
        verified: "আপনার মোবাইল নম্বর যাচাই হয়েছে।",
        or: "অথবা",
    },
    account: {
        title: "আমার অর্ডার",
        link: "আমার অর্ডার",
        signInTitle: "আপনার অর্ডার দেখুন",
        signInBody: "যে মোবাইল নম্বরে অর্ডার করেছেন সেটি দিন। আমরা একটি কোড পাঠাব।",
        signedInAs: "{{who}} হিসেবে সাইন ইন করা",
        signOut: "সাইন আউট",
        empty: "এখনো কোনো অনলাইন অর্ডার নেই।",
        placedOn: "{{date}} অর্ডার করা",
        items_one: "{{count}}টি পণ্য",
        items_other: "{{count}}টি পণ্য",
        back: "আমার সব অর্ডার",
        status: {
            draft: "খসড়া",
            pending: "পাওয়া গেছে",
            confirmed: "কনফার্ম হয়েছে",
            packed: "প্যাক হয়েছে",
            shipped: "পথে আছে",
            delivered: "ডেলিভারি হয়েছে",
            partially_delivered: "আংশিক ডেলিভারি",
            returned: "ফেরত এসেছে",
            cancelled: "বাতিল",
        },
        payment: {
            unpaid: "এখনো পেমেন্ট হয়নি",
            partially_paid: "আংশিক পেমেন্ট",
            paid: "পেমেন্ট হয়েছে",
            cod_pending: "ডেলিভারিতে পেমেন্ট",
            refunded: "ফেরত দেওয়া হয়েছে",
        },
        deliverTo: "ডেলিভারির ঠিকানা",
        progress: "অগ্রগতি",
        trackTitle: "অর্ডার {{number}}",
    },
    coupon: {
        label: "কুপন কোড",
        apply: "প্রয়োগ করুন",
        remove: "সরান",
        discount: "ছাড় ({{code}})",
        freeDelivery: "ফ্রি ডেলিভারি ({{code}})",
        automatic: "অফার প্রয়োগ হয়েছে: {{code}}",
        problems: {
            COUPON_NOT_APPLICABLE: "এই কোডটি আপনার কার্টে প্রযোজ্য নয়।",
            COUPON_EXPIRED: "এই কোডের মেয়াদ শেষ।",
            COUPON_MIN_ORDER: "এই কোড ব্যবহার করতে কার্টে আরো পণ্য যোগ করুন।",
            COUPON_LIMIT_REACHED: "এই কোডের ব্যবহার শেষ।",
        },
    },
    reviews: {
        title: "রিভিউ",
        none: "এখনো কোনো রিভিউ নেই।",
        average: "৫-এর মধ্যে {{average}}",
        count_one: "{{count}}টি রিভিউ",
        count_other: "{{count}}টি রিভিউ",
        reply: "দোকানের উত্তর",
        stars: "{{rating}} স্টার",
        more: "আরো রিভিউ",
        write: "আপনার কেনা পণ্যের রিভিউ দিন",
        rating: "আপনার রেটিং",
        text: "আপনার মতামত (ঐচ্ছিক)",
        send: "রিভিউ পাঠান",
        thanks: "রিভিউর জন্য ধন্যবাদ!",
        waiting: "ধন্যবাদ! দেখানোর আগে দোকান এটি যাচাই করবে।",
        order: "অর্ডার {{number}} থেকে",
    },
    wishlist: {
        title: "সেভ করা পণ্য",
        save: "সেভ করুন",
        saved: "সেভ করা আছে",
        empty: "এখনো কিছু সেভ করা নেই।",
        signIn: "পণ্য সেভ করতে সাইন ইন করুন",
    },
    landing: {
        orderTitle: "এখনই অর্ডার করুন",
        option: "বেছে নিন",
        quantity: "পরিমাণ",
        unitPrice: "দাম",
        codOnly: "ক্যাশ অন ডেলিভারি — হাতে পেয়ে টাকা দিন।",
        deliveryNote: "আপনার এলাকার ডেলিভারি চার্জ মোটের সাথে যোগ হবে। নিশ্চিত করতে আমরা আপনাকে কল করব।",
        place: "অর্ডার নিশ্চিত করুন",
        placing: "অর্ডার হচ্ছে…",
        unavailable: "এই পণ্যটি এখন অর্ডার করা যাচ্ছে না।",
        countdown: {
            days: "দিন",
            hours: "ঘণ্টা",
            minutes: "মিনিট",
            seconds: "সেকেন্ড",
            ended: "এই অফার শেষ হয়ে গেছে।",
        },
    },
    engine: {
        close: "বন্ধ করুন",
        previous: "আগেরটি",
        next: "পরেরটি",
        slide: "{{total}}টির মধ্যে {{n}} নম্বর",
        carousel: "পণ্য",
        decrease: "পরিমাণ কমান",
        increase: "পরিমাণ বাড়ান",
        quantity: "পরিমাণ",
        rating: "৫-এর মধ্যে {{value}}",
        reviewsCount: "({{n}})",
        compare: "আগে ও পরে তুলনা করতে টানুন",
        before: "আগে",
        after: "পরে",
        code: "এসএমএসে আসা কোড",
        digit: "{{n}} নম্বর অঙ্ক",
        undo: "ফিরিয়ে আনুন",
        added: "কার্টে যোগ হয়েছে",
        drawer: {
            emptyBody: "দোকান ঘুরে পছন্দের জিনিস যোগ করুন — এখানে আপনার জন্য রাখা থাকবে।",
            each: "প্রতিটি {{price}}",
            couponToggle: "কুপন কোড আছে?",
            removed: "{{name}} সরানো হয়েছে",
            updating: "আপডেট হচ্ছে",
            freeDeliveryMissing: "আর {{amount}}-এর পণ্য নিলে ডেলিভারি ফ্রি",
            freeDeliveryReached: "আপনার ডেলিভারি ফ্রি",
            cartLabel: "কার্ট, {{count}}টি পণ্য",
            /** ST-19: the automatic offer the cart is closest to (amount and offer filled in). */
            offerMissing: "আর {{amount}}-এর পণ্য নিলে {{offer}}",
            count_one: "{{n}}টি পণ্য",
            count_other: "{{n}}টি পণ্য",
        },
        // ST-19: automatic offers in words (cart line, product page note).
        offer: {
            percent: "{{percent}} ছাড়",
            amount: "{{amount}} ছাড়",
            cap: "সর্বোচ্চ {{amount}}",
            from: "{{min}} বা তার বেশি অর্ডারে {{offer}}",
            always: "প্রতিটি অর্ডারে {{offer}}",
            label: "অফার",
        },
        // ST-17 (single_product "Launch"): the pack choice, the live total and the calls to order.
        // ST-23 (home_food "Rannaghor"): the menu card and the delivery checker.
        boighor: {
            search: "বই, লেখক, প্রকাশনী বা আইএসবিএন খুঁজুন",
            subjects: "বিষয়",
            authors: "লেখক",
            ebooks: "ইবুক",
            readHere: "এই ওয়েবসাইটেই পড়ুন",
            seeAll: "সব দেখুন",
            library: "আমার লাইব্রেরি",
            tagline: "সব পাঠকের জন্য বই — ঘরে পৌঁছে যায়, অথবা পড়ুন এখানেই।",
        },
        rannaghor: {
            checkDelivery: "ডেলিভারি দেখুন",
            menu: "আমাদের মেনু",
            menuKicker: "অর্ডার অনুযায়ী তৈরি",
        },
        // ST-22 (kids_baby "Tuntuni"): ages and the gift finder.
        tuntuni: {
            byAge: "বয়স অনুযায়ী",
            giftFinder: "উপহার খুঁজুন",
        },
        // ST-21 (home_kitchen "Nest"): rooms, shop the room, inspiration, fragile items.
        nest: {
            shopTheRoom: "পুরো ঘর থেকে কিনুন",
            tapDots: "বিন্দুতে চাপুন, জিনিসটি দেখুন",
            inspiration: "অনুপ্রেরণা",
            rooms: "রুম",
            materials: "উপাদান ও যত্ন",
            homes: "আপনাদের ঘরে",
            fragile: "ভঙ্গুর: বাবল র‍্যাপ মুড়িয়ে শক্ত বাক্সে প্যাক করা হয়।",
        },
        // ST-20 (jewellery "Noor"): gift wish on the product page, occasions, the gift guide.
        gift: {
            gift: "এটি উপহার — মুড়িয়ে দিন, ভেতরে দাম থাকবে না",
            message: "কার্ডের বার্তা (ঐচ্ছিক)",
            hint: "চেকআউটে এটি আপনার অর্ডার নোটে যোগ হবে।",
            note: "উপহার: অনুগ্রহ করে মুড়িয়ে দিন, ভেতরে দাম রাখবেন না।",
            noteWith: "উপহার: অনুগ্রহ করে মুড়িয়ে দিন, ভেতরে দাম রাখবেন না। কার্ডের বার্তা: {{message}}",
        },
        noor: {
            styleWith: "সাথে মানাবে",
            giftGuide: "উপহার নির্দেশিকা",
            shop: "দেখুন",
            scroll: "নিচে দেখুন",
        },
        // ST-19 (fashion_men "Shaan"): size boxes, combos and the fit band.
        shaan: {
            sizesOf: "{{name}}-এর সাইজ",
            colours_one: "{{n}}টি রং",
            colours_other: "{{n}}টি রং",
            shopAll: "সব পণ্য দেখুন",
            comboKicker: "একসাথে কিনুন, কম দিন",
            fitKicker: "সাইজ গাইড",
        },
        // ST-18 (cosmetics "Lavanya"): authenticity, the skin quiz and "suitable for".
        lavanya: {
            original: "১০০% অরিজিনাল",
            promise: "প্রতিটি পণ্য অরিজিনাল, অনুমোদিত আমদানিকারকের কাছ থেকে — ব্যাচ ও মেয়াদের তারিখসহ।",
            quiz: "স্কিন কুইজ",
            step: "প্রশ্ন {{n}}/{{total}}",
            back: "পেছনে",
            showing: "আপনার জন্য মানানসই পণ্য দেখাচ্ছি…",
            suitableFor: "যাদের জন্য",
            shades_one: "{{n}}টি শেড",
            shades_other: "{{n}}টি শেড",
        },
        launch: {
            choose: "{{option}} বেছে নিন",
            bestValue: "সবচেয়ে সাশ্রয়ী",
            stepOrder: "আপনার অর্ডার",
            stepDelivery: "কোথায় পৌঁছে দেব?",
            summary: "অর্ডারের সারাংশ",
            deliveryPending: "জেলা বেছে নিন",
            missing: "এখনো বাকি: {{fields}}",
            choice: "আপনার বাছাই",
            phoneHint: "অর্ডার নিশ্চিত করতে এই নম্বরে ফোন করব।",
            phoneInvalid: "০১ দিয়ে শুরু ১১ সংখ্যার মোবাইল নম্বর লিখুন।",
            nameMissing: "আপনার নাম লিখুন।",
            addressMissing: "বাসা, রোড আর এলাকা লিখুন।",
            namePlaceholder: "যেমন: রহিমা আক্তার",
            phonePlaceholder: "০১XXXXXXXXX",
            addressPlaceholder: "বাসা, রোড, এলাকা",
            addressHint: "যাতে কুরিয়ার আপনাকে খুঁজে পায় — কাছের কোনো চিহ্ন লিখলে ভালো।",
            checkFirst: "টাকা দেওয়ার আগে ডেলিভারিম্যানের সামনে দেখে নিন।",
            weCall: "পাঠানোর আগে ফোন করে নিশ্চিত করব।",
            orCall: "ফোনে অর্ডার করতে চান?",
            subtotal: "দাম",
            discount: "অফার",
            delivery: "ডেলিভারি",
            total: "মোট",
            updating: "মোট হিসাব হচ্ছে…",
            noAdvance: "অগ্রিম টাকা লাগবে না — হাতে পেয়ে টাকা দিন।",
            placeTotal: "অর্ডার নিশ্চিত করুন · {{total}}",
            orderNow: "এখনই অর্ডার করুন",
            callToOrder: "ফোনে অর্ডার",
            orderBar: "অর্ডার",
            yes: "হ্যাঁ",
            no: "না",
        },
        compareList: {
            add: "তুলনা",
            added: "তুলনায় আছে",
            full: "সর্বোচ্চ ৩টি তুলনা করা যায়",
            tray: "পণ্য তুলনা",
            open: "তুলনা করুন ({{n}})",
            clear: "মুছুন",
            remove: "{{name}} বাদ দিন",
            title: "তুলনা",
            intro: "পাশাপাশি, প্রতিটি পণ্যের স্পেসিফিকেশন থেকে।",
            empty: "কার্ডে “তুলনা” চেপে সর্বোচ্চ ৩টি পণ্য বেছে নিন, এখানে পাশাপাশি দেখাবে।",
            browse: "পণ্য দেখুন",
            price: "দাম",
            availability: "স্টক",
            view: "দেখুন",
            missing: "—",
            same: "শুধু পার্থক্য দেখান",
            all: "সব সারি দেখান",
        },
        footer: { shop: "কেনাকাটা", help: "সাহায্য", follow: "অনুসরণ করুন", all: "সব পণ্য", contact: "যোগাযোগ" },
        chrome: {
            // ST-16: the grocery header and the phone cart bar.
            deliveringTo: "{{place}}-এ ডেলিভারি",
            deliveringToDays: "{{place}}-এ ডেলিভারি · {{days}}",
            deliveryEverywhere: "সারা বাংলাদেশে ডেলিভারি",
            searchGrocery: "মধু, ঘি, খেজুর খুঁজুন…",
            cartBar: "আপনার কার্ট",
            cartBarItems_one: "{{n}}টি পণ্য",
            cartBarItems_other: "{{n}}টি পণ্য",
            skipToContent: "মূল অংশে যান",
            chatWhatsapp: "হোয়াটসঅ্যাপে কথা বলুন",
            chatMessenger: "মেসেঞ্জারে কথা বলুন",
            trust: "কেন আমাদের থেকে কিনবেন",
            menu: "মেনু",
            openMenu: "মেনু খুলুন",
            search: "খুঁজুন",
            searchTitle: "দোকানে খুঁজুন",
            recent: "সাম্প্রতিক খোঁজ",
            clear: "মুছুন",
            trending: "জনপ্রিয় খোঁজ",
            products: "পণ্য",
            categories: "ক্যাটাগরি",
            seeAll: "“{{q}}”-এর সব ফলাফল দেখুন",
            noResults: "“{{q}}”-এর সাথে কিছু মেলেনি। অন্য শব্দ লিখুন বা বানান দেখুন।",
            searchFailed: "এখন খোঁজা যাচ্ছে না। একটু পরে আবার চেষ্টা করুন।",
            viewAll: "সব {{name}} দেখুন",
            dismiss: "বার্তাটি লুকান",
            home: "হোম",
            account: "অ্যাকাউন্ট",
            cartTab: "কার্ট",
            myOrders: "আমার অর্ডার",
            wishlist: "পছন্দের তালিকা",
        },
        card: {
            new: "নতুন",
            colours: "রং",
            quickAdd: "কার্টে যোগ করুন",
            quickView: "এক নজরে দেখুন",
            viewDetails: "বিস্তারিত দেখুন",
            save: "{{name}} সেভ করুন",
            // ST-16 (grocery cards): "+ Add" that turns into a stepper, weight chips and the price per kilo.
            add: "যোগ করুন",
            addItem: "{{name}} কার্টে যোগ করুন",
            quantityOf: "{{name}}-এর পরিমাণ",
            sizes: "{{name}}-এর সাইজ",
            perKg: "{{price}}/কেজি",
            perL: "{{price}}/লিটার",
        },
        list: {
            price: "দাম (৳)",
            min: "সর্বনিম্ন",
            max: "সর্বোচ্চ",
            brand: "ব্র্যান্ড",
            publisher: "প্রকাশনী",
            author: "লেখক",
            format: "ধরন",
            formats: { physical: "ছাপা বই", digital: "ইবুক" },
            showResults: "ফলাফল দেখুন",
            clearAll: "সব মুছুন",
            subcategories: "উপ-ক্যাটাগরি",
            showing: "{{n}}টি পণ্য দেখানো হচ্ছে",
            active: "বেছে নেওয়া ফিল্টার",
            remove: "{{name}} সরান",
            loading: "লোড হচ্ছে…",
            grid: "গ্রিড",
            dense: "ছোট গ্রিড",
            list: "তালিকা",
            view: "দেখার ধরন",
        },
        product: {
            buyNow: "এখনই কিনুন",
            zoom: "বড় করে দেখুন",
            sizeGuide: "সাইজ গাইড",
            units: { inch: "মাপ ইঞ্চিতে", cm: "মাপ সেন্টিমিটারে" },
            fitTitle: "আপনার সাইজ বের করুন",
            measurement: "মাপ",
            yourMeasure: "আপনার",
            suggestion: "{{size}} সাইজ আপনার হবে।",
            noSuggestion: "আমাদের সবচেয়ে বড় সাইজের চেয়েও বড় — আমাদের ফোন করুন।",
            howToMeasure: "কীভাবে মাপবেন",
            deliveryTo: "ডেলিভারি",
            chooseDistrict: "জেলা বেছে নিন",
            deliveryLine: "ডেলিভারি {{charge}} · {{days}}",
            deliveryLineNoDays: "ডেলিভারি {{charge}}",
            days: "{{min}}–{{max}} দিন",
            freeFrom: "{{amount}} বা বেশি অর্ডারে ডেলিভারি ফ্রি",
            share: "শেয়ার",
            whatsapp: "হোয়াটসঅ্যাপ",
            facebook: "ফেসবুক",
            copyLink: "লিংক কপি করুন",
            copied: "লিংক কপি হয়েছে",
            specs: "স্পেসিফিকেশন",
            deliveryReturns: "ডেলিভারি ও রিটার্ন",
            readPolicies: "পুরো নীতি পড়ুন",
            pairs: "এর সাথে মানানসই",
            bundle: "একসাথে: {{price}}",
            related: "আপনার ভালো লাগতে পারে",
            recent: "সম্প্রতি দেখেছেন",
        },
        order: {
            title: "অর্ডার করতে ফর্মটি পূরণ করুন",
            searchDistrict: "জেলা খুঁজুন…",
            searchUpazila: "এলাকা খুঁজুন…",
            address: "পুরো ঠিকানা (বাড়ি, রোড, গ্রাম)",
            required: "চিহ্নিত ঘরগুলো পূরণ করুন।",
            shipping: "ডেলিভারি চার্জ",
            discount: "ছাড়",
            orderWith: "এখনই অর্ডার করুন — {{method}}",
            payWith: "{{method}} দিয়ে {{amount}} পরিশোধ করুন",
            steps: { order: "অর্ডার", check: "যাচাই", confirm: "নিশ্চিত", done: "সম্পন্ন" },
            progress: {
                orderTitle: "আপনার অর্ডার পাঠানো হচ্ছে",
                orderBody: "আপনার তথ্য দোকানে পাঠানো হচ্ছে।",
                checkTitle: "তথ্য যাচাই হচ্ছে",
                checkBody: "ফোন নম্বর, ঠিকানা আর স্টক যাচাই হচ্ছে।",
                confirmTitle: "অর্ডার নিশ্চিত হচ্ছে",
                confirmBody: "অর্ডার হয়ে গেছে — রসিদ তৈরি হচ্ছে।",
                doneTitle: "সব হয়ে গেছে",
                doneBody: "আপনার অর্ডার নিশ্চিত।",
                keepOpen: "অনুগ্রহ করে পাতাটি রিফ্রেশ বা বন্ধ করবেন না।",
            },
            success: {
                thanks: "ধন্যবাদ, {{name}}!",
                confirmed: "আপনার অর্ডার #{{number}} নিশ্চিত হয়েছে।",
                next: "ডেলিভারি নিশ্চিত করতে আমরা শিগগিরই ফোন বা এসএমএস করব।",
                details: "ক্রেতার তথ্য",
                contact: "যোগাযোগ",
                address: "ডেলিভারির ঠিকানা",
                track: "অর্ডার ট্র্যাক করুন",
            },
        },
        placed: {
            call: "অর্ডার আর ঠিকানা নিশ্চিত করতে আমরা ফোন বা এসএমএস করব।",
            pack: "যত্ন করে আপনার অর্ডার প্যাক করা হবে।",
            deliver: "কুরিয়ার আপনার কাছে পৌঁছে দেবে — পণ্য হাতে পেয়ে টাকা দিন (ক্যাশ অন ডেলিভারি)।",
        },
        gallery: {
            title: "ইঞ্জিন গ্যালারি",
            intro: "শপ থিমের সব অংশ, এই শপের থিমে সাজানো। প্রোডাকশনে দেখা যায় না।",
            sheet: "ড্রয়ার",
            dialog: "ডায়ালগ",
            openRight: "ডান দিক থেকে খুলুন",
            openLeft: "বাম দিক থেকে খুলুন",
            openBottom: "নিচ থেকে খুলুন",
            openDialog: "ডায়ালগ খুলুন",
            carousel: "ক্যারোসেল",
            tabs: "ট্যাব",
            accordion: "অ্যাকর্ডিয়ন",
            controls: "পছন্দ, পরিমাণ, রেটিং ও দাম",
            countdown: "কাউন্টডাউন",
            toast: "বার্তা",
            showToast: "একটি বার্তা দেখান",
            motion: "অ্যানিমেশন",
            marquee: "৳২,০০০-এর বেশি অর্ডারে ফ্রি ডেলিভারি · ক্যাশ অন ডেলিভারি · সহজ এক্সচেঞ্জ",
            hotspots: "লুকটি কিনুন",
            beforeAfter: "আগে ও পরে",
            otp: "ওয়ান-টাইম কোড",
            fonts: "থিমের ফন্ট",
            fontSample: "ঈদের নতুন কালেকশন — বাছাই করা, পৌঁছে যাবে আপনার দরজায়",
            bengali: "বাংলা লেখা",
            sample: "ক্ষমা, ন্ত্র, র‍্যাব, ব্যাগ, স্বপ্ন, শ্রী, জ্ঞান, কৃষ্ণ — সারা দেশে ক্যাশ অন ডেলিভারি।",
        },
    },
    sections: shopSections,
    policies: { returns: "রিটার্ন ও রিফান্ড", delivery: "ডেলিভারি", privacy: "গোপনীয়তা", terms: "শর্তাবলি" },
    social: {
        facebook: "ফেসবুক",
        instagram: "ইনস্টাগ্রাম",
        youtube: "ইউটিউব",
        tiktok: "টিকটক",
        whatsapp: "হোয়াটসঅ্যাপ",
    },
};
//# sourceMappingURL=shop.js.map